import Task from 'components/framework/models/Task';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class TaskFields extends RecordFields {
  static modelClass = Task;
}

registerRecordFieldsClasses({ TaskFields });
